import { render } from "./EditMatchView.vue?vue&type=template&id=375c122d"
import script from "./EditMatchView.vue?vue&type=script&lang=js"
export * from "./EditMatchView.vue?vue&type=script&lang=js"

import "./EditMatchView.vue?vue&type=style&index=0&id=375c122d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__